module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/remove-click-delay-fastclick-152.vue");


//////////////////
// WEBPACK FOOTER
// ./en/development/remove-click-delay-fastclick.md
// module id = 570
// module chunks = 407